import constants from '$$helpers/constants';

export default function (instance, ganttData) {
  instance.ganttDataApi.getTasksForWorkloadByProjectId = (resourceId, projectId) => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    if (!projectTasksData) {
      return [];
    }

    const resourceData = instance.ganttDataApi.getResourceById(resourceId);
    const resourceProjectSettings = resourceData.resourceProjects.find(o => +o.projectId === +projectId);

    if (resourceProjectSettings && resourceProjectSettings.type !== constants.RESOURCE_TIME_TYPE) {
      return [];
    }

    const tasksData = projectTasksData.tasks;
    const resourcesToTasks = projectTasksData.resourcesToTasks;
    const result = [];

    tasksData.forEach(task => {
      const assigned = resourcesToTasks[task.id]?.find(item => item.resource_id === +resourceId);

      if (assigned) {
        result.push({
          taskData: task,
          resource_id: resourceId,
          task_id: task.id,
          gantt_id: projectId,
          value: assigned.value,
          custom_days: assigned.custom_days,
          id: assigned.id,
        });
      }
    });

    return result;
  };

  instance.ganttDataApi.getTasksForWorkload = resourceId => {
    const projectsData = instance.ganttDataApi.getAllProjectTasksData();
    const result = [];

    projectsData.forEach(projectData => {
      if (projectData.is_archived !== 1) {
        const tasks = instance.ganttDataApi.getTasksForWorkloadByProjectId(resourceId, projectData.id);
        // let accessToTasks = true;

        // if (!rights.project.hasRight(projectData.id, 'all_tasks') || !rights.project.hasRight(projectData.id, 'static_fields')) {
        //   accessToTasks = false;
        // }

        tasks.forEach(task => {
          task._onlyForWorkloadCalculation = projectData._onlyForWorkloadCalculation; // || !accessToTasks;

          result.push(task);
        });
      }
    });

    return result;
  };

  instance.ganttDataApi.getScopedTasksForWorkload = (resourceId, ganttIds) => {
    const projectsData = instance.ganttDataApi.getAllProjectTasksData();
    let result = [];

    projectsData.forEach(projectData => {
      if (projectData.is_archived !== 1 && !projectData._onlyForWorkloadCalculation && ganttIds.includes(+projectData.id)) {
        const tasks = instance.ganttDataApi.getTasksForWorkloadByProjectId(resourceId, projectData.id);

        result = result.concat(tasks);
      }
    });

    return result;
  };

  instance.ganttDataApi.getUnassignedTasksForWorkload = ganttIds => {
    const projectsData = instance.ganttDataApi.getAllProjectTasksData();
    let result = [];

    projectsData.forEach(projectData => {
      if (projectData.is_archived !== 1 && !projectData._onlyForWorkloadCalculation && ganttIds.includes(+projectData.id)) {
        let unassignedTasks = projectData.tasks.filter(task => task.type !== constants.TASK_TYPES.project && !projectData.resourcesToTasks[task.id]);

        unassignedTasks = unassignedTasks.map(taskData => ({
          taskData,
          resource_id: null,
          task_id: taskData.id,
          gantt_id: taskData.gantt_id,
          value: 0,
          custom_days: [],
        }));

        result = result.concat(unassignedTasks);
      }
    });

    return result;
  };

  instance.ganttDataApi.getAssignedResourcesOnTask = (projectId, taskId) => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    return projectTasksData?.resourcesToTasks[taskId] || [];
  };
}
